import { Price } from './price.model';

export class Product {
  attributes: string[];
  description: string;
  id: string;
  images: any;
  metadata: any;
  name: string;
  type: string;
  prices: Price[];

  constructor(x?: Product | any) {
    this.attributes = x.details.attributes || [];
    this.description = x.details.description || '';
    this.id = x.details.id || '';
    this.images = x.details.images || '';
    this.metadata = x.details.metadata || '';
    this.name = x.details.name || '';
    this.type = x.details.type || '';
    this.prices = x.prices || [];
  }
}
